import { render, staticRenderFns } from "./edit-student-policy-form.vue?vue&type=template&id=1650cfa1&scoped=true&"
import script from "./edit-student-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-student-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650cfa1",
  null
  
)

export default component.exports